export const FEATURES_TABLE_DATA = [
  {
    id: 1,
    feature: 'Presto Canvas Editor',
    some: true,
  },
  {
    id: 2,
    feature: 'Instantly Auto Size Content to Any Size of Sign',
    some: false,
  },
  {
    id: 7,
    feature: 'Seamless Integration Between Content Creation and Scheduling',
    some: true,
  },
  {
    id: 8,
    feature: 'Generative AI Design Assistant',
    some: false,
  },
  {
    id: 9,
    feature: 'Cloud-Based Software (Access from Anywhere)',
    some: true
  },
  {
    id: 10,
    feature: 'Access to over 1,200 Premade Templates',
    some: true,
  }
];
